import React from 'react';
import { useApp } from '../../context/AppContext';
import { Tab } from '../../types';
import { triggerTapFeedback } from '../../utils/feedback';

interface NavItemProps {
  key?: string;
  navKey: string;
  en: string;
  bn: string;
  Icon: React.ComponentType<{ className?: string }>;
  onTabClick?: () => void;
}

export default function NavItem({ navKey, en, bn, Icon, onTabClick }: NavItemProps) {
  const { lang, activeTab, setActiveTab } = useApp();
  const active = activeTab === navKey;

  return (
    <button
      id={`nav-tab-${navKey}`}
      onClick={() => {
        triggerTapFeedback();
        if (navKey === 'search') {
          window.dispatchEvent(new Event('open-search-overlay'));
          return;
        }
        setActiveTab(navKey as Tab);
        if (onTabClick) onTabClick();
      }}
      className="relative flex flex-col items-center justify-center py-1 sm:py-2 px-1 rounded-xl cursor-pointer transition-all duration-300 group flex-1 min-w-0 bg-transparent"
    >
      <div className={`relative mb-1.5 w-10 h-10 sm:w-11 sm:h-11 rounded-full flex items-center justify-center transition-all duration-300 border ${
        active
          ? 'glass-button-neon bg-primary/20 text-primary dark:text-white border-primary/40 shadow-[0_0_15px_rgba(var(--theme-rgb),0.3)] scale-105 backdrop-blur-md'
          : 'bg-neutral-100/60 dark:bg-white/5 text-neutral-600 dark:text-neutral-400 border-neutral-200/40 dark:border-white/10 hover:bg-primary/10 hover:text-primary hover:border-primary/30'
      }`}>
        <Icon 
          className={`w-4.5 h-4.5 sm:w-5 sm:h-5 transition-transform duration-300 group-hover:scale-110 ${
            active 
              ? 'stroke-[2.5px] drop-shadow-[0_2px_4px_rgba(0,0,0,0.2)]' 
              : 'stroke-[2px]'
          }`} 
        />
      </div>

      <span className={`text-[10px] sm:text-[11px] tracking-wide transition-colors uppercase truncate max-w-full px-0.5 leading-none ${
        active 
          ? 'text-primary font-black' 
          : 'text-neutral-600 dark:text-neutral-400 font-extrabold group-hover:text-primary'
      }`}>
        {lang === 'en' ? en : bn}
      </span>
    </button>
  );
}
